module.exports = __webpack_public_path__ + "static/img/14.c287e78.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/1/sp/14.png
// module id = CBfC
// module chunks = 0